import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('service-header-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {

        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.initReveal();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initReveal() {
            gsap.to(this.$el.querySelectorAll('.services-header__image-overlay'), {
                duration: 2,
                delay: 0.6,
                y: '-100%',
                stagger: 0.2,
                ease: 'power4.inOut',
                onComplete: () => {
                    this.revealCompleted = true;
                },
            });
            gsap.to(this.$el.querySelectorAll('.services-header__image'), {
                duration: 2, delay: 0, scale: 1, stagger: 0.2, ease: 'power2.out',
            });
            gsap.to(this.$el.querySelectorAll('.services-header'), {
                duration: 4, delay: 0, y: '0%', ease: 'power2.inOut',
            });
        },
    },
});
